import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import "./styles/Status.css";

function StatusRAIDComponent(props) {
  if (props.dataArray) {
    return (
      <Box sx={{ textAlign: "center" }}>
        <Box className="statusTableTitle" sx={{ backgroundColor: "darkgreen" }}>
          {"RAID: " +
            props.raidType.charAt(0).toUpperCase() +
            props.raidType.slice(1) +
            "s"}
        </Box>
        <Table className="statusTable">
          <TableBody>
            <TableRow className="statusTableHeaderRow">
              <TableCell className="statusTableColumnHeader">Name</TableCell>
              <TableCell className="statusTableColumnHeader">
                Synopsis
              </TableCell>
              <TableCell className="statusTableColumnHeader">Stage</TableCell>
              <TableCell className="statusTableColumnHeader">
                Priority
              </TableCell>
            </TableRow>
            {props.dataArray.map((elem, index) => (
              <TableRow key={index} className="statusTableRow">
                <TableCell className="statusTableCell">{elem.name}</TableCell>
                <TableCell className="statusTableCell">
                  {elem.description}
                </TableCell>
                <TableCell className="statusTableCell">
                  {elem.issue_stage_name}
                </TableCell>
                <TableCell className="statusTableCell">
                  {elem.issue_severity_name}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default StatusRAIDComponent;

StatusRAIDComponent.propTypes = {
  dataArray: PropTypes.array,
  raidType: PropTypes.string,
};

/*
     <table className="statusTable">
        <tr className="statusTableRow">
          <td className="statusTableColumnHeader">Metric</td>
          <td className="statusTableColumnHeader">Value</td>
        </tr>
        <tr className="statusTableRow">
          <td className="statusTableCell">
            Actual {props.metricsObject.suffix}
          </td>
          <td className="statusTableCell">{props.metricsObject.actualValue}</td>
        </tr>
      </table>
      */
